import type { TFile } from "../../models/file-model";
import { FilesGridPresentational } from "./FilesGridPresentational";

type Props = {
  files: TFile[];
  isLoadingFiles: boolean;
  selectedFileIds: string[];

  onSelectFile: (target: TFile) => void;
};

export const FilesGridContainer = (props: Props) => {
  return (
    <FilesGridPresentational
      files={props.files ?? []}
      onSelectFile={props.onSelectFile}
      isLoadingFiles={props.isLoadingFiles}
      selectedFileIds={props.selectedFileIds}
    />
  );
};
